module.exports = __webpack_public_path__ + "img/top_one@3x.ce241582.png";